import { dracoInitialize } from 'playcanvas'

let initialized = false

/**
 * Initialize the PlayCanvas Draco worker pool. Must run BEFORE any GLB load
 * (the engine decodes KHR_draco_mesh_compression via these workers). Safe to
 * call more than once — only the first call takes effect.
 */
export function initDraco(): void {
  if (initialized) return
  initialized = true
  dracoInitialize({
    jsUrl: '/draco/draco.wasm.js',
    wasmUrl: '/draco/draco.wasm.wasm',
    numWorkers: 2,
  })
}
